import { useSystemSetting } from "@/api/services/admin/system-setting";
import { InnerBox } from "@/modules/irohana-components/elements/InnerBox";
import { LoadingPage } from "@/modules/irohana-components/elements/Loading/Loading";
import { MaintenanceForm } from "@/features/system-setting/components/MaintenanceForm";
import { convertMaintenanceSettingResToForm } from "@/features/system-setting/utils/converts";
import { FC } from "react";

type TMaintenanceSettingPageProps = {};

export const MaintenanceSettingPage: FC<TMaintenanceSettingPageProps> = () => {
  const { data: systemSettingResult, isLoading } = useSystemSetting();

  if (isLoading) return <LoadingPage />;
  return (
    <InnerBox width="100%" mx="auto" sx={{ borderRadius: "0 0 8px 8px" }}>
      <MaintenanceForm previousData={systemSettingResult ? convertMaintenanceSettingResToForm(systemSettingResult.data) : undefined} />
    </InnerBox>
  );
};
